import React from "react";
import { MaskLine } from "../components/Motion";

const BLOCKS = [
  ["Shipping", "Orders ship from California. First-drop pre-orders ship the week of September 15, 2026. Standard shipping is free on orders over $100; otherwise a flat $8 (US). International rates and duties are shown at checkout."],
  ["Delivery times", "US: 3–6 business days after dispatch. Canada & UK: 6–10 business days. Australia: 8–14 business days. You'll receive tracking by email once your order leaves us."],
  ["Returns", "Free returns within 14 days of delivery on unworn items with original tags. Start a return from your confirmation email or by contacting hey@covertswag.com. Refunds land within 5–7 business days of us receiving the item."],
  ["Pre-order cancellations", "Change your mind before it ships? Pre-orders can be cancelled any time before dispatch for a full refund — just email us."],
  ["Exchanges", "Need a different size? Send the original back for a free return and place a new order. This keeps limited stock moving fairly for everyone."],
];

export default function Shipping() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-16 sm:py-24" data-testid="shipping-page">
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-graytx mb-4">Logistics</p>
      <h1 className="font-display font-extrabold text-5xl sm:text-7xl uppercase leading-[0.85]"><MaskLine>Shipping &</MaskLine><MaskLine delay={0.1}>Returns</MaskLine></h1>
      <div className="mt-12">
        {BLOCKS.map(([t, b], i) => (
          <div key={i} className="py-8 border-t border-line">
            <h3 className="font-display font-extrabold text-xl uppercase">{t}</h3>
            <p className="text-graytx mt-3 leading-relaxed">{b}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
